import React from "react";
import { formatMonto } from "../../utils";
import usePreciario from "../../hooks/usePreciario";

const Montos = () => {
  const {
    extra,
    pagos,
    anticipo,
    ejecutado,
    autorizado,
    autorizadoOriginal,
    autorizadoExtra,
    estimacion,
    totalPagos,
    totalCuenta,
    porAmortizar,
    totalAmortizado,
    porcentajeCuenta,
    porcentajeAnticipo,
  } = usePreciario();

  function getPagoSugerido() {
    let pago = estimacion.ejecutado;
    let restante = totalPagos - anticipo;
    if (restante < anticipo) {
      let amortizado = (pago * porcentajeAnticipo) / 100;
      pago = amortizado;
    }
    return formatMonto(pago);
  }

  function renderMontoEstimacion() {
    if (estimacion && estimacion !== null) {
      return (
        <>
          <div className="row py-2">
            <div className="col">Monto de estimacion #{estimacion.numero}</div>
            <div className="col text-end">
              {"$"}
              {formatMonto(estimacion.ejecutado)}
            </div>
          </div>
          {anticipo > 0 && (
            <div className="row py-2">
              <div className="col">
                Pago Sugerido ({getPagoSugerido()}% de Anticipo)
              </div>
              <div className="col text-end">
                {"$"}
                {getPagoSugerido()}
              </div>
            </div>
          )}
        </>
      );
    }
  }

  function renderMontoExtra() {
    if (extra && extra !== null) {
      return (
        <div className="row py-2">
          <div className="col">Monto ejecutado en extras</div>
          <div className="col text-end">
            {"$"}
            {formatMonto(extra)}
          </div>
        </div>
      );
    }
  }

  function renderAnticipo() {
    if (Array.isArray(pagos)) {
      if (pagos.length > 0) {
        if (anticipo > 0) {
          return (
            <>
              <div className="row border-bottom py-2">
                <div className="col px-0 bold">Anticipo ({porcentajeAnticipo}%)</div>
                <div className="col px-0 text-end">
                  {"$"}
                  {formatMonto(anticipo)}
                </div>
              </div>
              <div className="row border-bottom py-2">
                <div className="col px-0">Pagos a Cuenta</div>
                <div className="col px-0 text-end">
                  {"$"}
                  {formatMonto(totalCuenta)}
                </div>
              </div>
              <div className="row border-bottom py-2">
                <div className="col px-0">
                  Anticipo + Pagos a Cuenta <span className="small">({porcentajeCuenta}%)</span>
                </div>
                <div className="col px-0 text-end">
                  {"$"}
                  {formatMonto(anticipo + totalCuenta)}
                </div>
              </div>
              <div className="row border-bottom py-2">
                <div className="col px-0">Pagos Amortizados</div>
                <div className="col px-0 text-end">
                  {"$"}
                  {formatMonto(totalAmortizado)}
                </div>
              </div>
              <div className="row border-bottom py-2">
                <div className="col px-0 bold">Por Amortizar</div>
                <div className="col px-0 text-end">
                  {"$"}
                  {formatMonto(porAmortizar)}
                </div>
              </div>
            </>
          );
        }
      }
    }
  }

  const diferencial = ejecutado - totalPagos;

  return (
    <div className="card p-3 shadow">
      <h4 className="h6 bold">Montos fijos de obra</h4>
      <div className="container-fluid mb-3">
        <div className="row py-2 border-top">
          <div className="col px-0">Contrato Autorizado</div>
          <div className="col px-0 text-end">
            {"$"}
            {formatMonto(autorizado)}
          </div>
        </div>
        <div className="row py-1">
          <div className="col px-0 ps-3 small text-muted">Original</div>
          <div className="col px-0 text-end small text-muted">
            {"$"}
            {formatMonto(autorizadoOriginal)}
          </div>
        </div>
        <div className="row py-1">
          <div className="col px-0 ps-3 small text-muted">Extras</div>
          <div className="col px-0 text-end small text-muted">
            {"$"}
            {formatMonto(autorizadoExtra)}
          </div>
        </div>
        {renderAnticipo()}
      </div>
      <h4 className="h6 bold">Montos variables de obra</h4>
      <div className="container-fluid">
        {renderMontoEstimacion()}
        {renderMontoExtra()}
        <div className="row py-2 border-top">
          <div className="col px-0">Ejecutado</div>
          <div className="col px-0 text-end">
            {"$"}
            {formatMonto(ejecutado)}
          </div>
        </div>
        <div className="row py-2 border-top">
          <div className="col px-0">Pagado</div>
          <div className="col px-0 text-end">
            {"$"}
            {formatMonto(totalPagos)}
          </div>
        </div>
        <div className="row py-2 border-top">
          <div className="col px-0">Por Ejecutar</div>
          <div className="col px-0 text-end">
            {"$"}
            {formatMonto(autorizado - ejecutado)}
          </div>
        </div>
        <div className="row py-2 border-top">
          <div className="col px-0">Ejecutado - Pagado</div>
          <div className={`col px-0 text-end ${diferencial < 0 ? "text-danger" : ""}`}>
            {"$"}
            {formatMonto(diferencial)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Montos;
